import React, {Component} from 'react';
import {NavLink as Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {AsyncLoginForm} from './loginForm';
import {StyledLink} from '../fields/renderFields';
import {CenteredContainer as Container} from '../fields/ContainerFields';
import {DoubleLeftOutlined} from '@ant-design/icons';
import {Typography} from 'antd';

const {Title} = Typography;

class LoginPage extends Component {
  render() {
    const {isLoading} = this.props;
    return (
      <Container style={{width: '100vw', height: '100vh'}}>
        <Link to="/">
          <DoubleLeftOutlined style={{fontSize: '3em', marginTop: '4em'}} />
        </Link>
        <div
          style={{
            padding: 24,
            textAlign: 'center',
            width: '30%',
            marginTop: '10em',
            minWidth: '30em',
          }}
        >
          <div style={{paddingTop: 12, paddingBottom: 12}}>
            <Title level={2}>CREATIVE LOGIN</Title>
            <Title level={4}>Login to your Creative Account </Title>
          </div>
          <AsyncLoginForm isLoading={isLoading} />
          <div>
            <StyledLink to="#">Forgot your password? Click Here</StyledLink>
            <br />
            <StyledLink to="/sign-up">Not a member? Click here to create your account!</StyledLink>
          </div>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isLoading: state.auth.isLoading,
  };
};

export default connect(mapStateToProps, {})(LoginPage);
